import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const familyFoldersSharingInFavorites = isFeature('family-folders-sharing-in-favorites');
